<template>
  <v-dialog v-model="dialog" content-class="v-dialog--custom"
    :fullscreen="$vuetify.breakpoint.xsOnly">
    <v-form ref="form" v-model="valid" @submit.prevent="submit()">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <alert-message></alert-message>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <vault-folder-select
                  v-model="form.parentId"
                  label="Type"
                  :filter-id="form.id"
                  :error-messages="[].concat(fieldErrors('form.parentId'))"
                  @blur="$v.form.parentId.$touch()"
                  :solo="false"
                ></vault-folder-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" sm="12" md="12">
                <v-text-field
                  v-model="form.name"
                  label="Name"
                  :error-messages="[].concat(fieldErrors('form.name'))"
                  @blur="$v.form.name.$touch()"
                ></v-text-field>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="darken-1" @click="dialog = false">Cancel</v-btn>
          <v-btn
            :disabled="$v.$invalid"
            type="submit"
            color="info"
            :loading="loading"
          >
            {{ isEdit ? "Save" : "Add" }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import UTIL from "src/helpers/utility";
import { mapActions, mapState, mapGetters } from "vuex";
// import _ from "lodash";
import AlertMessage from "src/components/AlertMessage";
import VaultFolderSelect from "components/VaultFolderSelect";
import { required } from "vuelidate/lib/validators";
import validationMixin from "@/mixins/validationMixin";

export default {
  components: {
    AlertMessage,
    VaultFolderSelect
  },
  props: {
    item: [Object, String],
    show: [Boolean, String],
  },
  mixins: [validationMixin],
  validations: {
    form: {
      name: { required },
      parentId: { }
    }
  },
  validationMessages: {
    form: {
      name: {
        required: "Name required",
      },
      parentId: {
        required: "Type required",
      }
    },
  },

  data() {
    return {
      showDialog: this.show,
      typeItems: ["Labor", "Parts"],
      form: {
        id: "",
        name: "",
        parentId: 0,
      },
      dialog: false,
      valid: false,
      loading: false,
    };
  },

  watch: {
    show(n, o) {
      if (n && !o) {
        this.dialog = true;
      }
    },
    dialog(n, o) {
      if (!n && o) {
        this.onDialogClose();
      } else {
        this.onDialogOpen();
      }
    },
    item(n, o) {
      if (n && JSON.stringify(n) !== JSON.stringify(o)) {
        this.form = {
          ...n
        };
      }
    },
  },

  computed: {
    ...mapGetters("account", ["hasAccess"]),
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
    }),
    formTitle() {
      return this.isEdit ? "Edit Vault Folder" : "Add Vault Folder";
    },
    isEdit() {
      return UTIL.gv(this.item, "id", "") ? true : false;
    },
  },

  created() {},

  methods: {
    ...mapActions("vaultFolder", ["create", "update"]),
    onDialogClose() {
      if (this.isEdit) {
        //
      } else {
        //
      }
      this.$emit("onClosed");
    },
    onDialogOpen() {
      this.$nextTick(() => {
        // clear error state
        this.$store.dispatch("alert/clear");
        this.$v.$reset();
      });
    },
    save() {},
    addNew() {
      this.dialog = true;
      this.form = {
        id: "",
        name: "",
        parentId: 0,
      };
    },

    completed() {
      this.$emit("onSucceded");
    },

    async submit() {
      this.loading = true;
      if (!this.valid) {
        this.$store.dispatch("snackbar/error", "Form invalid");
        return false;
      }

      let payload = {
        ...this.form
      };

      if (this.isEdit) {
        await this.update(payload);
      } else {
        delete payload.id;
        await this.create(payload);
      }

      if (!this.account.status.error) {
        this.dialog = false;
        this.completed();
      }
      this.loading = false;
    },
  },
};
</script>